import { useState } from 'react'
import { useTranslation } from 'libs/i18n'
import { useForm } from 'libs/form'
import { ColorPicker } from 'shared/components'
import { InputGroup } from 'shared/molecules'
import { Field, fieldButtonClassName } from '../Field'
import { Position, usePlacement } from '../../placement'
import { useCircleValidationSchema } from './hooks/useCircleValidationSchema'

type CircleProps = {
	floormapConfig: any[]
	onSubmit: (data: any) => void
}

export const Circle = ({ floormapConfig, onSubmit }: CircleProps) => {
	const { t } = useTranslation()
	const [color, setColor] = useState('#BBBBBB')
	const validationResolver = useCircleValidationSchema()

	const {
		handleSubmit,
		register,
		formState: { errors }
	} = useForm({
		resolver: validationResolver,
		mode: 'onChange'
	})

	const submitCircle = ({ radius }: any, position: Position = { x: 45, y: 70 }) => {
		onSubmit([
			...floormapConfig,
			{
				type: 'circle',
				...position,
				radius: +radius,
				fill: color,
				draggable: true,
				id: crypto.randomUUID()
			}
		])
	}

	usePlacement('circle', (position) => handleSubmit((data) => submitCircle(data, position))())

	return (
		<Field label={t('Circle')} section="circle" isPlaceable>
			<form className="space-y-2" onSubmit={handleSubmit((data) => submitCircle(data))}>
				<InputGroup
					id="floor-map-circle-radius"
					label={t('Radius')}
					placeholder={t('radius (px)')}
					{...register('radius')}
					error={(errors as any).radius}
				/>
				<ColorPicker
					id="floor-map-circle-color"
					label={t('Color')}
					color={color}
					onChange={({ hex }) => setColor(hex)}
				/>
				<button type="submit" className={fieldButtonClassName}>
					{t('Add circle')}
				</button>
			</form>
		</Field>
	)
}
